import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-2" }
const _hoisted_2 = {
  key: 0,
  class: "modal-content-container col-12"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "pt-3 px-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h6", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Issues Creating Task")
    ])
  ])
], -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-2" }, null, -1 /* HOISTED */)
const _hoisted_5 = { class: "px-2" }
const _hoisted_6 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "h2 fas fa-question-circle tooltip-blue fa-2xl" }, null, -1 /* HOISTED */)
const _hoisted_8 = { class: "h6 ms-2" }
const _hoisted_9 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "h2 fas fa-times text-danger fa-2xl" }, null, -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "h6 ms-2" }, " This task cannot be created because of the following errors. Please review the errors, change the task as needed, and try again. ", -1 /* HOISTED */)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = { class: "validations-box mt-4 overflow-auto" }
const _hoisted_14 = { class: "single-validation mb-4 pb-2 rounded-top" }
const _hoisted_15 = ["data-bs-target"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1 /* HOISTED */)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1 /* HOISTED */)
const _hoisted_18 = ["id"]
const _hoisted_19 = { class: "m-0 pt-3 text-wrap medium-text" }
const _hoisted_20 = {
  key: 0,
  class: "p-2 d-flex align-items-center border rounded mt-3 position-relative"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", {
  "aria-label": "required",
  class: "text-danger h4 position-absolute"
}, " * ", -1 /* HOISTED */)
const _hoisted_22 = ["value", "id"]
const _hoisted_23 = ["for"]
const _hoisted_24 = { class: "mt-0 d-flex pb-2 px-3 justify-content-center" }
const _hoisted_25 = ["disabled"]
const _hoisted_26 = {
  key: 1,
  class: "modal-content-container col-12"
}
const _hoisted_27 = { class: "pt-3 px-3" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", { class: "mb-2" }, null, -1 /* HOISTED */)
const _hoisted_29 = { class: "px-2" }
const _hoisted_30 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "h2 fas fa-question-circle tooltip-blue fa-2xl" }, null, -1 /* HOISTED */)
const _hoisted_32 = { class: "h6 ms-2" }
const _hoisted_33 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", { class: "h2 fas fa-times text-danger fa-2xl" }, null, -1 /* HOISTED */)
const _hoisted_35 = { class: "h6 ms-2" }
const _hoisted_36 = { class: "validations-box mt-4 overflow-auto" }
const _hoisted_37 = { class: "single-validation mb-4 pb-2 rounded-top" }
const _hoisted_38 = ["data-bs-target"]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1 /* HOISTED */)
const _hoisted_40 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" }, null, -1 /* HOISTED */)
const _hoisted_41 = ["id"]
const _hoisted_42 = { class: "m-0 pt-3 medium-text text-wrap" }
const _hoisted_43 = {
  key: 0,
  class: "p-2 d-flex align-items-center border rounded mt-3 position-relative"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("span", {
  "aria-label": "required",
  class: "text-danger h4 position-absolute"
}, " * ", -1 /* HOISTED */)
const _hoisted_45 = ["value", "id"]
const _hoisted_46 = ["for"]
const _hoisted_47 = { class: "d-flex py-2 px-3 justify-content-center" }
const _hoisted_48 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isScheduleVisitComponent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            (!_ctx.hasError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
                  _hoisted_7,
                  _createElementVNode("span", _hoisted_8, " There were some issues creating the task. If you would like to continue creating, check \"Create Anyway\" in each section and click Continue. If you would like to cancel, click Back to to " + _toDisplayString(_ctx.name) + " Calendar. ", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.hasError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_9, _hoisted_12))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validations, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.title
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        "data-bs-toggle": "collapse",
                        "data-bs-target": '#title-' + index,
                        "aria-expanded": true,
                        class: "p-2 w-100 text-white border-0 bg-transparent d-flex justify-content-between align-items-center au-target"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */),
                        _hoisted_16,
                        _hoisted_17
                      ], 8 /* PROPS */, _hoisted_15)
                    ]),
                    _createElementVNode("div", {
                      id: 'title-' + index,
                      class: "collapse show bg-white mx-2 pb-2 px-4"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.description, (text) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "validtion-des-list",
                          key: item.title + index
                        }, [
                          _createElementVNode("pre", _hoisted_19, _toDisplayString(text), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      (!_ctx.hasError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _hoisted_21,
                            _withDirectives(_createElementVNode("input", {
                              onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.validationSelected())),
                              type: "checkbox",
                              value: 'title' + index,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.validationsAccepted) = $event)),
                              id: 'title' + index
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_22), [
                              [_vModelCheckbox, _ctx.validationsAccepted]
                            ]),
                            _createElementVNode("label", {
                              for: 'title' + index,
                              class: "ms-2 au-target mb-0"
                            }, " Create Anyway ", 8 /* PROPS */, _hoisted_23)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_18)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_24, [
              (!_ctx.hasError)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    disabled: !_ctx.enableContinue,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ok())),
                    class: "btn btn-xs me-2 btn-outline-primary"
                  }, " Continue ", 8 /* PROPS */, _hoisted_25))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.cancel())),
                type: "button",
                class: "btn btn-xs btn-primary"
              }, _toDisplayString(_ctx.isPlanner ? "Cancel" : `Back to ${_ctx.name} Calendar`), 1 /* TEXT */)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", null, [
              _createElementVNode("h6", null, [
                _createElementVNode("strong", null, "Issues " + _toDisplayString(_ctx.isRestoreVisitComponent ? "Restoring" : "Rescheduling") + " Task", 1 /* TEXT */)
              ])
            ])
          ]),
          _hoisted_28,
          _createElementVNode("div", _hoisted_29, [
            (!_ctx.hasError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_30, [
                  _hoisted_31,
                  _createElementVNode("span", _hoisted_32, " There were some issues updating the task. If you would like to continue updating, check \"" + _toDisplayString(_ctx.isRestoreVisitComponent ? "Restore" : "Reschedule") + " Anyway\" in each section and click Continue. If you would like to cancel, click Back to " + _toDisplayString(_ctx.name) + " Calendar. ", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            (_ctx.hasError)
              ? (_openBlock(), _createElementBlock("p", _hoisted_33, [
                  _hoisted_34,
                  _createElementVNode("span", _hoisted_35, " This task cannot be " + _toDisplayString(_ctx.isRestoreVisitComponent ? "restored" : "rescheduled") + " because of the following errors. Please review the errors, change the task as needed, and try again. ", 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_36, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validations, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.title
                }, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("div", null, [
                      _createElementVNode("button", {
                        "data-bs-toggle": "collapse",
                        "data-bs-target": '#title-' + index,
                        "aria-expanded": true,
                        class: "p-2 w-100 text-white border-0 bg-transparent d-flex justify-content-between align-items-center au-target"
                      }, [
                        _createElementVNode("span", null, _toDisplayString(item.title), 1 /* TEXT */),
                        _hoisted_39,
                        _hoisted_40
                      ], 8 /* PROPS */, _hoisted_38)
                    ]),
                    _createElementVNode("div", {
                      id: 'title-' + index,
                      class: "collapse show bg-white mx-2 pb-2 px-4"
                    }, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.description, (text) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "validtion-des-list",
                          key: item.title + index
                        }, [
                          _createElementVNode("pre", _hoisted_42, _toDisplayString(text), 1 /* TEXT */)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */)),
                      (!_ctx.hasError)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                            _hoisted_44,
                            _withDirectives(_createElementVNode("input", {
                              onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.validationSelected())),
                              type: "checkbox",
                              value: 'title' + index,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.validationsAccepted) = $event)),
                              id: 'title' + index
                            }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_45), [
                              [_vModelCheckbox, _ctx.validationsAccepted]
                            ]),
                            _createElementVNode("label", {
                              for: 'title' + index,
                              class: "ms-2 au-target mb-0"
                            }, _toDisplayString(_ctx.isRestoreVisitComponent ? "Restore" : "Reschedule") + " Anyway ", 9 /* TEXT, PROPS */, _hoisted_46)
                          ]))
                        : _createCommentVNode("v-if", true)
                    ], 8 /* PROPS */, _hoisted_41)
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ]),
            _createElementVNode("div", _hoisted_47, [
              (!_ctx.hasError)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    disabled: !_ctx.enableContinue,
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.ok())),
                    class: "btn btn-xs me-2 btn-outline-primary"
                  }, " Continue ", 8 /* PROPS */, _hoisted_48))
                : _createCommentVNode("v-if", true),
              _createElementVNode("button", {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.cancel())),
                type: "button",
                class: "btn btn-xs btn-primary"
              }, " Back to " + _toDisplayString(_ctx.name) + " Calendar ", 1 /* TEXT */)
            ])
          ])
        ]))
  ]))
}